import moment from 'moment'

export const formatDate = (date: string | Date): string => {
  return moment(date).format('DD/MM/YYYY HH:mm')
}

export const getDealEnabledDates = (date: Date): Date[] => {
  const prevMonth = moment(date).subtract(1, 'month').startOf('month')
  const currentMonth = moment(date).startOf('month')
  const nextMonth = moment(date).add(1, 'month').startOf('month')

  return [
    prevMonth.toDate(),
    new Date(prevMonth.format('YYYY-MM-10')),
    new Date(prevMonth.format('YYYY-MM-20')),
    currentMonth.toDate(),
    new Date(currentMonth.format('YYYY-MM-10')),
    new Date(currentMonth.format('YYYY-MM-20')),
    nextMonth.toDate(),
    new Date(nextMonth.format('YYYY-MM-10')),
    new Date(nextMonth.format('YYYY-MM-20')),
  ]
}
